export default __webpack_public_path__ + "static/media/store.05500cfe.jpg";